import * as React from "react";
import { forwardRef } from "react";
const SvgGoBackIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.5 19.5L3 12M3 12L10.5 4.5M3 12H21", stroke: "#6192BE", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgGoBackIcon);
export { ForwardRef as ReactComponent };
